import { Checkbox } from 'primereact/checkbox';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEnabledBodyTemplate = (checkBox: any) => {
  return <Checkbox checked={checkBox.isEnabled} disabled></Checkbox>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAttentionNeededBodyTemplate = (checkBox: any) => {
  return <Checkbox checked={checkBox.isAttentionNeeded} disabled></Checkbox>;
};
